import { Avatar, type AvatarProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

type LpFieldProps = Omit<AvatarProps, "children"> & {
    value: number | string;
    sx?: SxProps<Theme>;
};

export const LpField = ({ value, sx = {}, ...rest }: LpFieldProps) => {
  const base: SxProps<Theme> = {
    width: 26, height: 26, fontSize: 12, fontWeight: 700,
    fontVariantNumeric: "tabular-nums", bgcolor: "grey.200", color: "text.primary",
  };
  return (
    <Avatar variant="rounded" sx={[base, sx] as SxProps<Theme>} {...rest}>
      {value}
    </Avatar>
  );
};

